export const MESSAGE_TYPES = {
    BIRTHDAY: 'יום הולדת',
    GENERAL: 'כללית',
  };
  
  export const TARGET_TYPES = {
    GLOBAL: 'גלובלי',
    CITY: 'ערים',
    STREET: 'רחובות',
    BUILDING: 'בניינים',
  };
  
  export const TARGET_TYPES_HEBREW = {
    global: "גלובלי",
    city: "ערים",
    street: "רחובות",
    building: "בניינים",
  };

  export const MESSAGE_OPTIONS = {
    FIXED: 'קבועה',
    UNTIL_DATE: 'עד תאריך',
    FROM_DATE: 'מתאריך',
  };
  
  export const SORT_BY = {
    DATE_CREATED: 'תאריך יצירה',
    MESSAGE_TYPE: 'סוג הודעה',
    TARGET_TYPE: 'סוג יעד',
  };
  